import '../App.css';
import About from '../components/About';

var Info = () => {
  const containerClasses = `second-container text-align-left ${window.innerWidth < 500 ? '' : 'padding-md'}`;

  return (
    <div className={containerClasses}>
      <About />
    </div>
  );
};

export default Info;
